type HTMLClass = string | string[] | { [key: string]: boolean };

enum RowVariant {
	STACK = 'stack',
	FLEX = 'flex',
}

enum RowAlignment {
	CENTER = 'center',
	START = 'start',
	END = 'end',
	REVERSE = 'reverse',
}

interface Breakpoint {
	up?: number;
	down?: number;
	classes?: HTMLClass;
}

export {
	HTMLClass,
	RowVariant,
	RowAlignment,
	Breakpoint
};
